import React from "react";
import classes from "./NotFound.module.css";

export default function NotFound() {
  return (
    <div className={classes["NotFound_container"]}>404 - Page Not Found</div>
  );
}
